import React, { useContext, useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';

import {
    Accordion,
    AccordionDetails,
    AccordionSummary,
    Container,
    Divider,
    Grid,
    LinearProgress,
    Typography
} from '@mui/material';

import ExpandMoreIcon from '@mui/icons-material/ExpandMore';

import { PageHeader } from '../../common';
import { FetchContext, NavContext } from '../../contexts';
import { ContattoDetails, UfficioDetails } from './components';
import { StoricoUfficioContext, StoricoUfficioProvider } from './StoricoUfficioContext';

const PageContent = (props) => {

    const {
        user
    } = useContext(FetchContext);

    const {
        addBreadcrumbToken,
        setBread,
        goBack,
        navigateTo,
    } = useContext(NavContext);

    const {
        state,
        setState,

        isLoadingStoricoUfficio,
        getStoricoUfficioAsync,
    } = useContext(StoricoUfficioContext)

    const {
        storicoUfficio
    } = state;

    const {
        ufficioId,
        storicoId,
    } = useParams();

    const [isLoading, setIsLoading] = useState(false);
    useEffect(() => {
        setIsLoading(isLoadingStoricoUfficio);
    }, [isLoadingStoricoUfficio])

    useEffect(() => {
        if (user && storicoUfficio)
            addBreadcrumbToken(`Storico ufficio "${storicoUfficio.dataCreazione.toLocaleString("it-IT")}"`);
    }, [storicoUfficio, user]);

    useEffect(() => {
        if (user && ufficioId && storicoId)
            getStoricoUfficioAsync(ufficioId, storicoId);
    }, [ufficioId, storicoId, user]);

    if (!user)
        return <Container>
            <LinearProgress />
        </Container>

    return (
        <>
            <Container>
                {isLoading && <LinearProgress />}
                <Grid container>
                    <Grid item xs={12}>
                        <PageHeader
                            disabled={isLoading}
                            title={storicoUfficio && `Storico Ufficio del ${storicoUfficio.dataCreazione.toLocaleString("it-IT")} - ${storicoUfficio.creatoDaUtente?.nome} ${storicoUfficio.creatoDaUtente?.cognome}`}
                            subtitle={`Visualizza i cambiamenti`} />
                    </Grid>
                    <Grid item xs={12} sx={{ marginTop: 3 }}>
                        <UfficioDetails />
                        <Divider />
                    </Grid>
                    <Grid item xs={12} sx={{ marginTop: 3 }}>
                        <Accordion>
                            <AccordionSummary
                                expandIcon={<ExpandMoreIcon sx={{ color: "white" }} />}
                                aria-controls="contatti-panel"
                                id="contatti-panel"
                                sx={{
                                    color: "white",
                                    backgroundColor: "secondary.main",
                                }}
                            >
                                <Typography variant="h6">Attributi</Typography>
                            </AccordionSummary>
                            <AccordionDetails>
                                {
                                    storicoUfficio?.valore.Contatti.map((e, index) => {

                                        var previousVal = storicoUfficio?.valorePrecedente?.Contatti?.find(x => x.Id == e.Id);

                                        return (<Grid key={index} item xs={12}>
                                            <ContattoDetails
                                                contatto={e}
                                                previousContatto={previousVal}
                                            />
                                        </Grid>)


                                    })
                                }
                                {
                                    storicoUfficio?.valorePrecedente?.Contatti?.filter(x => storicoUfficio?.valore?.Contatti?.map(y => y.Id).indexOf(x.Id) < 0).map((e, index) => {
                                        return (<Grid key={index} item xs={12}>
                                            <ContattoDetails
                                                contatto={e}
                                                previousContatto={null}
                                                isDeleted={true}
                                            />
                                        </Grid>)
                                    })
                                }
                            </AccordionDetails>
                        </Accordion>
                        <Divider />
                    </Grid>
                </Grid>
            </Container>
        </>
    );
}

export const StoricoUfficioPage = () => {

    return (
        <StoricoUfficioProvider>
            <PageContent />
        </StoricoUfficioProvider>
    );
}